import { z } from "zod";

export const ContaReceberSchema = z.object({
    idContasReceber: z.number().optional().nullable(),
    idCentroCusto: z.number().optional().nullable(),
    idSubconta: z.number().optional().nullable(),
    idCliente: z.number().optional().nullable(),
    idClienteCentroCusto: z.number().optional().nullable(),
    idOrdemCompra: z.number().optional().nullable(),
    idBancoPagamento: z.number().optional().nullable(),
    idFuncionario: z.number().optional().nullable(),
    status: z.coerce.number().refine((val) => [0, 1, 2, 3, 4].includes(val), {
        message: "Tipo de data inválida.",
    }).default(0),
    nrContasReceber: z.string().optional().nullable(),
    valorReceber: z.coerce.number().positive({ message: "O valor a receber deve ser positivo." }),
    multa: z.coerce.number().optional().nullable(),
    juros: z.coerce.number().optional().nullable(),
    desconto: z.coerce.number().optional().nullable(),
    nome: z.string().optional().nullable(),
    dataReceber: z.coerce.date({ invalid_type_error: "Data a Receber inválida." }).nullable().default(null),
    dataBaixa: z.coerce.date({ invalid_type_error: "Data a Recebido inválida." }).nullable().default(null),
    dataCriacao: z.date().optional().nullable().default(null),
    dataCompetencia: z.coerce.date({ invalid_type_error: "Data a Recebido inválida." }).nullable().default(null),
    competencia: z.string().optional().nullable(),
    nrNotaFiscal: z.string().optional().nullable(),
    nrDocumentos: z.string().optional().nullable(),
    valorBaixa: z.coerce.number().optional().nullable(),
    observacao: z.string().optional().nullable(),
    outros: z.string().optional().nullable(),
    formaPagamento: z.string().optional().nullable(),

    arquivo1: z.instanceof(File).nullable().default(null),
    nomeArquivo1: z.string().optional().nullable(),

    arquivo2: z.instanceof(File).nullable().default(null),
    nomeArquivo2: z.string().optional().nullable(),

    arquivo3: z.instanceof(File).nullable().default(null),
    nomeArquivo3: z.string().optional().nullable(),

    limparArquivo1: z.coerce.boolean().default(false),
    limparArquivo2: z.coerce.boolean().default(false),
    limparArquivo3: z.coerce.boolean().default(false),


});

export type ContaReceberForm = z.infer<typeof ContaReceberSchema>;

export const defaultContaReceberForm: Partial<ContaReceberForm> = {
    status: 0

}